export const CHAT_ANIMATION = {
  spring: { type: "spring", stiffness: 500, damping: 30, mass: 1 },
  fadeIn: { opacity: 0, y: 20 },
  fadeOut: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0 },
} as const;

export const MESSAGE_STYLES = {
  user: "rounded-lg border border-desert-sand-400 bg-ivory-mist-100 p-3 text-sm leading-relaxed text-foreground",
  ai: "rounded-2xl rounded-bl-md p-3 text-sm leading-relaxed text-foreground",
} as const;

export const ACTION_BUTTON_STYLE = "flex rounded-md bg-[#585451] p-1 text-xs text-white";
